import { useGetApiWorkspacesByIdDataConsoleAvailabilityQuery } from '@/model/dataConsole/api.generated';
import { useAppSelector } from '@/shared/hooks/useStore';
import {
  selectCurrentWorkspace,
  useWorkspacePermissionsViewModel,
} from '@/viewmodel/features/workspace';
import { skipToken } from '@reduxjs/toolkit/query/react';

export function useWorkspaceDataAvailability(): { canOpen: boolean; isLoading: boolean } {
  const workspace = useAppSelector(selectCurrentWorkspace);
  const permissions = useWorkspacePermissionsViewModel();
  const canManage = permissions.can('data_share:manage');
  const { data, isLoading } = useGetApiWorkspacesByIdDataConsoleAvailabilityQuery(
    workspace && canManage ? { id: workspace.id } : skipToken,
  );

  return {
    canOpen: canManage && data?.data.available === true,
    isLoading: permissions.isLoading || isLoading,
  };
}
